import type { ICommonContext } from '~/entities/auth'
import { NewsOwnerTypeEnum } from '~/shared/api'
import { NewsModuleSlugEnum } from '~/shared/const'
import { permissions } from '~/shared/lib'

export type AccessFunction = [permission: string, ctx?: Partial<ICommonContext> | null, isBackend?: boolean]

export interface ISubModuleConfig {
  submodulePermissions: {
    PERMISSION: string
    ROUTE: string
    CREATE: {
      ROUTE: string
      PERMISSION: string
      SELECT_PROJECT?: {
        ROUTE: string
        PERMISSION: string
      }
    }
    EDIT: {
      ROUTE: string
      PERMISSION: string
    }
    DETAIL: {
      ROUTE: string
      PERMISSION: string
    }
    COMMENTS: {
      ROUTE: string
      PERMISSION: string
    }
    SPEECH_REVIEW?: {
      ROUTE: string
      PERMISSION: string
    }
    REORDER?: {
      ROUTE: string
      PERMISSION: string
    }
    SHOW_CREATE_NEWS_BTN: {
      PERMISSION: string
    }
    SHOW_EDIT_NEWS_BTN: {
      PERMISSION: string
    }
    SHOW_DELETE_NEWS_BTN: {
      PERMISSION: string
    }
  }
  moduleSlug?: NewsModuleSlugEnum
  title: string
  saveType?: NewsOwnerTypeEnum
  access: {
    showCreateNewsBtn: AccessFunction
    showEditNewsBtn: AccessFunction
    showDeleteNewsBtn: AccessFunction
  }
}

export const NEWS_SUBMODULE_CONFIG = {
  GLOBAL: {
    submodulePermissions: permissions.NEWS,
    title: 'Новости',
    access: {
      showCreateNewsBtn: [permissions.NEWS.SHOW_CREATE_NEWS_BTN.PERMISSION, null, true],
      showEditNewsBtn: [permissions.NEWS.SHOW_EDIT_NEWS_BTN.PERMISSION, null, true],
      showDeleteNewsBtn: [permissions.NEWS.SHOW_DELETE_NEWS_BTN.PERMISSION, null, true],
    },
  } as ISubModuleConfig,
  GENERAL_ENTERTAINMENT: {
    submodulePermissions: permissions.ENTERTAINMENT,
    title: 'Развлечения',
    saveType: NewsOwnerTypeEnum.User,
    access: {
      showCreateNewsBtn: [permissions.ENTERTAINMENT.SHOW_CREATE_NEWS_BTN.PERMISSION],
      showEditNewsBtn: [permissions.ENTERTAINMENT.SHOW_EDIT_NEWS_BTN.PERMISSION],
      showDeleteNewsBtn: [permissions.ENTERTAINMENT.SHOW_DELETE_NEWS_BTN.PERMISSION],
    },
    moduleSlug: NewsModuleSlugEnum.Entertainment,
  } as ISubModuleConfig,
  WORKSPACE: {
    submodulePermissions: permissions.PROJECTS.WORKSPACE.NEWS,
    title: 'Новости',
    saveType: NewsOwnerTypeEnum.Project,
    access: {
      showCreateNewsBtn: [permissions.PROJECTS.WORKSPACE.NEWS.SHOW_CREATE_NEWS_BTN.PERMISSION, null, true],
      showEditNewsBtn: [permissions.PROJECTS.WORKSPACE.NEWS.SHOW_EDIT_NEWS_BTN.PERMISSION, null, true],
      showDeleteNewsBtn: [permissions.PROJECTS.WORKSPACE.NEWS.SHOW_DELETE_NEWS_BTN.PERMISSION, null, true],
    },
    moduleSlug: NewsModuleSlugEnum.ProjectNews,
  } as ISubModuleConfig,
  WORKSPACE_RIGHTS_OF_CONSUMER: {
    submodulePermissions: permissions.PROJECTS.WORKSPACE.RIGHTS_OF_CONSUMER,
    title: 'Права потребителя',
    saveType: NewsOwnerTypeEnum.Project,
    access: {
      showCreateNewsBtn: [permissions.PROJECTS.WORKSPACE.RIGHTS_OF_CONSUMER.SHOW_CREATE_NEWS_BTN.PERMISSION],
      showEditNewsBtn: [permissions.PROJECTS.WORKSPACE.RIGHTS_OF_CONSUMER.SHOW_EDIT_NEWS_BTN.PERMISSION],
      showDeleteNewsBtn: [permissions.PROJECTS.WORKSPACE.RIGHTS_OF_CONSUMER.SHOW_DELETE_NEWS_BTN.PERMISSION],
    },
    moduleSlug: NewsModuleSlugEnum.ConsumerRights,
  } as ISubModuleConfig,
  WORKSPACE_WHAT_TO_DO_IN_CASE_OF_ACCIDENT: {
    submodulePermissions: permissions.PROJECTS.WORKSPACE.WHAT_TO_DO_IN_CASE_OF_ACCIDENT,
    title: 'Что делать при аварии',
    saveType: NewsOwnerTypeEnum.Project,
    access: {
      showCreateNewsBtn: [permissions.PROJECTS.WORKSPACE.WHAT_TO_DO_IN_CASE_OF_ACCIDENT.SHOW_CREATE_NEWS_BTN.PERMISSION],
      showEditNewsBtn: [permissions.PROJECTS.WORKSPACE.WHAT_TO_DO_IN_CASE_OF_ACCIDENT.SHOW_EDIT_NEWS_BTN.PERMISSION],
      showDeleteNewsBtn: [permissions.PROJECTS.WORKSPACE.WHAT_TO_DO_IN_CASE_OF_ACCIDENT.SHOW_DELETE_NEWS_BTN.PERMISSION],
    },
    moduleSlug: NewsModuleSlugEnum.AccidentGuidance,
  } as ISubModuleConfig,
  WORKSPACE_MY_SPEECH: {
    submodulePermissions: permissions.PROJECTS.WORKSPACE.MY_SPEECH,
    title: 'Выступления',
    saveType: NewsOwnerTypeEnum.Project,
    access: {
      showCreateNewsBtn: [permissions.PROJECTS.WORKSPACE.MY_SPEECH.SHOW_CREATE_NEWS_BTN.PERMISSION],
      showEditNewsBtn: [permissions.PROJECTS.WORKSPACE.MY_SPEECH.SHOW_EDIT_NEWS_BTN.PERMISSION],
      showDeleteNewsBtn: [permissions.PROJECTS.WORKSPACE.MY_SPEECH.SHOW_DELETE_NEWS_BTN.PERMISSION],
    },
    moduleSlug: NewsModuleSlugEnum.MySpeech,
  } as ISubModuleConfig,
}
